<template>
   <BreadCrumb PageTitle="Ajouter un support de cours" />
    <AddSupportCours />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddSupportCours from "@/components/SupportDeCours/AddSupportCours.vue";
  
    export default defineComponent({
      name: "AddSupportCoursPage",
      components: {
        BreadCrumb,
        AddSupportCours,
      },
    });
  </script>

